export const appendTermsAndConditionsLink = (messages = []) => {
  if (!messages?.length) return [];

  return messages.map(messageItem => {
    if (!messageItem?.promoCode) return messageItem;

    const promoData = JSON.stringify({ promoCode: messageItem?.promoCode })
    const termsAndConditionsLink = `<a
            class="jos-show-terms-and-conditions"
            style="display: none;"
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            aria-expanded="false"
            data-promo='${promoData}'
            >* See details and exclusions</a>`

    return {
      ...messageItem,
      message: `${messageItem.message} ${termsAndConditionsLink}`
    }
  })
}